import { Link } from "gatsby"
import React, { useState } from "react"
import { Button, getHoverColor } from "shared/components"
import { TextField } from "shared/components/form"
import { LARGE_SCREEN_MEDIA_QUERY, MEDIUM_SCREEN_MEDIA_QUERY } from "shared/helpers/responsive_helpers"
import styled from "styled-components"
import { Title3 } from "."
import logo from "../images/logo-light.png"
import { GREY_COLOR, PRIMARY_COLOR_100, WHITE_COLOR } from "../styles"


const FooterGrid = styled.div`
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  margin: 0 auto;
  max-width: 1140px;
  padding: 0 1rem;

  @media ${ MEDIUM_SCREEN_MEDIA_QUERY } {
    grid-template-columns: 1fr 1fr;
  }

  @media ${ LARGE_SCREEN_MEDIA_QUERY } {
    grid-template-columns: 1fr 1fr 1fr;
  }
`

// tslint:disable-next-line: space-within-parens
const FooterLogoContainer = styled(Link)`
  display: block;
  margin-bottom: 20px;
  max-width: 200px;
  width: 70%;
`

const FooterContentLink = styled.a`
  display: block;
  color: ${ GREY_COLOR };
`

export const FooterComponent = () => {

  const [subscriberEmail, setSubscriberEmail] = useState( "" )
  const [formSubmitted, setFormSubmitted] = useState( false )
  const [errorMessage, setErrorMessage] = useState<null | string>( null )

  const handleSubmit = ( event: React.FormEvent<HTMLFormElement> ) => {
    event.preventDefault()

    fetch( "https://submit-form.com/stgCDe_qGzwJLAuwQseQi", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify( {
        "Email": subscriberEmail,
      } )
    } )
      .then( () => setFormSubmitted( true ) )
      .catch( () => setErrorMessage( "Sorry, an unknown error occurred" ) )
  }

  return (
    <footer className="bg-black pt-20">
      <FooterGrid>
        <div className="mb-10">
          <FooterLogoContainer to="/">
            <img src={ logo } />
          </FooterLogoContainer>
          <FooterContentLink href="tel:19052261110">905-226-1110</FooterContentLink>
          <FooterContentLink href="mailto:info@cuzy.ca">info@cuzy.ca</FooterContentLink>
          <FooterContentLink href="https://goo.gl/maps/VVrPDbczSy657TVV9" target="_blank">8611 Weston Road, Unit 23 A, Woodbridge, ON, L4L9P1</FooterContentLink>
        </div>
        <div className="mb-20">
          <Title3 className="mb-5">Quick Links</Title3>
          <a className="block font-semibold text-white mb-2" href="/">Home</a>
          <a className="block font-semibold text-white mb-2" href="/about-us">About Us</a>
          <a className="block font-semibold text-white mb-2" href="/products">Products</a>
          <a className="block font-semibold text-white mb-2" href="/contact">Contact</a>
        </div>
        <div className="mb-20">
          <Title3 className="mb-5">Stay Updated</Title3>
          <form onSubmit={ handleSubmit }>
            {
              formSubmitted ? (
                errorMessage ? (
                  <div className="bg-orange-lightest border-l-4 border-orange text-orange-dark p-4">
                    { errorMessage }
                  </div>
                ) : (
                  <div className="bg-teal-100 border-l-4 border-teal-500 text-teal-700 p-4 my-6">
                    Thanks for getting in touch! We will get back to you shortly.
                  </div>
                )
              ) : (
                <>
                  <TextField
                    name="email"
                    placeholder="Email"
                    label="Email"
                    labelStyle={ {
                        position: "absolute",
                        overflow: "hidden",
                        clip: "rect(0 0 0 0)",
                        height: "1px",
                        width: "1px",
                        margin: "-1px",
                        padding: "0",
                        border: "0"
                    } }
                    // tslint:disable-next-line: jsx-no-lambda
                    onChange={ ( e ) => setSubscriberEmail( e.target.value ) }
                    type="email"
                    value={ subscriberEmail }
                  />
                  <Button
                    className="w-full rounded-full"
                    color={ PRIMARY_COLOR_100 }
                    textColor={ WHITE_COLOR }
                    colorHover={ getHoverColor( PRIMARY_COLOR_100, WHITE_COLOR ) }
                  >
                    Subscribe
                  </Button>
                </>
              )
            }
          </form>
          <p className="text-white my-5">Don't forget to follow us &amp; subscribe to our news feeds!</p>
        </div>
      </FooterGrid>
      <div className="border-t-2 border-gray-100 text-white text-center py-2">
        <a href="https://onelocal.com/" target="_blank">Powered by OneLocal</a>
      </div>
    </footer>
  )
}


